import ModalMessage from "../ModalMessage/ModalMessage"
import Icon from "../Icon/Icon"
import "./GetApp.scss";
import useDevice from "../../../hooks/useDevice";
const GetApp = ({ onClose}) => {
    const { isMobile,isIOS,isAndroid } = useDevice();
    return (<ModalMessage
        style={{ maxHeight: "98dvh"}}
        onClose={onClose}
        children={<div className="d-flex f-column jcc">
            <p className="fs-sm2 fw-bold mt-24 ta-center">
                How to add HYK to your
                phone home screen?</p>
            <img src={isAndroid?"/GetApp/GetAppAndroid.png":"/GetApp/GetApp.png"} alt="GetApp" />
            <div className="d-flex f-row aic mx-48 mt-24">
                <div className="list-item-step">1</div>
                <div className="fs-real fw-bold ta-center">{isAndroid?'Tap “3 dots” in your browser':'Tap “share” in your browser'}</div>
                <Icon alias={isAndroid?"dots_get_app":"share_get_app"} width={24} height={24} color={isAndroid?"#FF3232":"#007DFE"} />
            </div>
            <div className="d-flex f-row aic mx-48 mt-16">
                <div className="list-item-step">2</div>
                <div className="fs-real fw-bold ta-center tt-capitalize">Tap “add to home screen”</div>
                <Icon alias={isAndroid?"add_square_get_app":"add_square_get_app"} width={24} height={24} color={isAndroid?"#FF3232":"#007DFE"} />
            </div>
            <button 
                className="btn red-outline-btn btn-full aic jcc fw-extra-bold mb-24 mt-24"
                style={{ height: '64px' }}
                onClick={() => onClose()}
            >
                <span>GOT IT</span>
            </button>
        </div>}

    />
    )
}
export default GetApp